exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".group-title{display:flex;align-items:center;margin-bottom:5px;-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.dropdown.active{visibility:visible}.dropdown.inactive{visibility:hidden;display:none}", ""]);

// exports
